import { motion } from 'framer-motion';
import { fadeUp, viewportOnce } from '../theme/theme';

/** Scroll-triggered reveal wrapper. Pass `variants` to override. */
export default function Reveal({
  children,
  variants = fadeUp,
  className = '',
  as = 'div',
  delay = 0,
  ...rest
}) {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      variants={variants}
      initial="hidden"
      whileInView="show"
      viewport={viewportOnce}
      transition={{ delay }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
}
